export const AUTH_USER = 'auth_user';
export const AUTH_ERROR = 'auth_error';
export const UNAUTH_USER = 'unauth_user';
export const AUTH_USER_PROFILE = 'auth_user_profile';
export const AUTH_VERIFY = 'auth_verify';
export const AUTH_TOKEN = 'auth_token';
export const SET_USERS = 'set_users';
export const AUTH_WEBSITE_CONFIG = 'auth_website_config'
